import { Map, List } from 'immutable'
import React, { useEffect, useMemo } from 'react'
import { connect as connectRedux } from 'react-redux'
import _compact from 'lodash/compact'
import { getPrimary } from '../../services/languages/index'
import { getBoundActions } from '../../actions/index'
import { createTitleGroupId } from '../../services/content/index'
import { SCREEN_TYPE_YOGA_TEACHERS } from '../../services/page-manager/entities/index'
import Jumbotron from '../JumbotronSubcategory/index'
import { URL_YOGA_PRACTICES } from '../../services/url/constants'
import Button, { TYPES } from '../Button/index'
import Sherpa, { TYPE_LARGE } from '../Sherpa/index'
import YogaTeachersPageTiles from './YogaTeachersPageTiles'

function YogaTeachersPage ({
  getPmScreen,
  staticText,
  pmSection,
  pmScreen,
  auth,
  user,
}) {
  const language = getPrimary(user.getIn(['data', 'language'], List()))
  const sectionIds = pmScreen.getIn([SCREEN_TYPE_YOGA_TEACHERS, language, 'data', 'sectionIds'], List())
  const section = pmSection.get(sectionIds.get(0), Map())
  const tabs = section.getIn(['data', 'data', 'tabs'], List())
  const isLoading = section.get('processing') !== false

  const titleGroupIds = useMemo(() => {
    const tabData = tabs.get(0) || Map()
    const tabContent = tabData.get('tabContent') || List()
    return _compact(tabContent.map((item) => {
      return createTitleGroupId(item.get('contentId'), item.get('contentType'))
    }).toJS())
  }, [tabs])

  useEffect(() => {
    if (section.size === 0 && !section.get('processing')) {
      getPmScreen({ screenType: SCREEN_TYPE_YOGA_TEACHERS, language })
    }
  }, [section])

  return (
    <section className="yoga-teachers-page">
      <Jumbotron
          auth={auth}
          description=""
          title={staticText.get('yogaTeachers')}
          setOverlayDialogVisible={() => {}}
          staticText={Map()}
          heroImage={Map()}
        />
        <div className="yoga-teachers-page__content">
          {isLoading
            ? <Sherpa type={TYPE_LARGE} />
            : <>
              {titleGroupIds.length > 0 && <YogaTeachersPageTiles
                titleGroupIds={titleGroupIds}
                language={language}
              />}
            </>
          }
        </div>
        <div className="yoga-teachers-page__footer">
          <p>{staticText.get('discoverMore')}</p>
          <Button
            type={TYPES.PRIMARY}
            url={URL_YOGA_PRACTICES}
          >
            {staticText.get('viewAll')}
          </Button>
        </div>
    </section>
  )
}

export default connectRedux(({
  staticText,
  pmSection,
  pmScreen,
  user,
  auth,
}) => ({
  staticText: staticText.getIn(['data', 'yogaTeachersPage', 'data'], Map()),
  pmSection,
  pmScreen,
  auth,
  user,
}), (dispatch) => {
  const actions = getBoundActions(dispatch)
  return {
    getPmScreen: actions.pmScreen.getPmScreen,
  }
})(YogaTeachersPage)
